package meineglasfaser.api.routes

import io.ktor.resources.*
import kotlinx.serialization.Serializable

@Serializable
data class PrefetchedEntry(
    val id: String,
    val label: String,
)

@Resource("/prefetch")
class PrefetchRoutes {
    @Resource("/network-categories")
    class NetworkCategories(val parent: PrefetchRoutes = PrefetchRoutes())

    @Resource("/networks")
    class Networks(val parent: PrefetchRoutes = PrefetchRoutes())

    @Resource("/addon-groups")
    class AddonGroups(val parent: PrefetchRoutes = PrefetchRoutes())

    @Resource("/customers")
    class Customers(val parent: PrefetchRoutes = PrefetchRoutes())

    @Resource("/surveys")
    class Surveys(val parent: PrefetchRoutes = PrefetchRoutes())

    @Resource("/tax-categories")
    class TaxCategories(val parent: PrefetchRoutes = PrefetchRoutes())
}
